<template>
    <div>
        <van-nav-bar title="无权访问"  />
        <van-panel title="Forbidden" desc="您没有权限访问" status="游客">
        </van-panel>
    </div>
</template>
<script>
import { Panel, NavBar, Dialog } from 'vant';

export default {
    name: 'Forbidden',
    data () {
        return {
        }
    },
    mounted() {
        Dialog.alert({
            title: '无权访问',
            message: '本公众号只允许公司员工访问,如果您是思科上海员工,请使用微信访问,并绑定员工号, 谢谢'
        }).then(() => {
            // on close
            window.close();
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Forbidden.vue